import React from "react";

interface SourceSubmitButtonProps {
  isSubmitting: boolean;
  buttonText: string;
  onSkip: () => void;
}

export const SourceSubmitButton: React.FC<SourceSubmitButtonProps> = ({
  isSubmitting,
  buttonText,
  onSkip,
}) => {
  return (
    <button
      onClick={onSkip}
      className="w-full py-2 px-4 text-gray-500 hover:text-gray-700 transition-colors duration-200 text-center text-sm"
    >
      건너뛰기
    </button>
  );
};
